import React from 'react';
import { Link } from 'react-router-dom';

// NOTE: This component no longer uses Button.css as styles are now centralized in global.css
// The Button.css file can be safely deleted after fully migrating to the new design system

// Available styles defined in global.css
const STYLES = ['btn-primary', 'btn-secondary', 'btn-danger', 'btn-success', 'btn-outline', 'btn-link'];
const SIZES = ['btn-sm', 'btn-lg'];

export const Button = ({
    children,
    type = 'button',
    onClick,
    buttonStyle = 'btn-primary',
    buttonSize,
    to,
    disabled = false,
    className = '',
    block = false
}) => {
    // Validate button style, default to primary if invalid
    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : 'btn-primary';
    
    // Build class string
    let buttonClass = `btn ${checkButtonStyle}`;
    
    // Add size if specified
    if (buttonSize && SIZES.includes(buttonSize)) {
        buttonClass += ` ${buttonSize}`;
    }
    
    // Add block class if specified
    if (block) {
        buttonClass += ' btn-block';
    }
    
    // Add any additional classes
    if (className) {
        buttonClass += ` ${className}`;
    }

    const button = (
        <button
            className={buttonClass}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            {children}
        </button>
    );

    // If 'to' prop is provided, wrap in Link component
    return to ? (
        <Link to={to} className={buttonClass} onClick={onClick}>
            {children}
        </Link>
    ) : button;
}